import { FC, useEffect, useState } from "react";
import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonMenuToggle,
  IonPage,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { menu } from "ionicons/icons";
import { useCommon } from "../../../common/useCommon";
import { updateConversionRateApi } from "../../../common/api/updateConversionRateApi";

const ConversionRate: FC = () => {
  const { conversionRate, setConversionRate } = useCommon();
  const [editRate, setEditRate] = useState<number>(conversionRate);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (conversionRate > 0) setEditRate(conversionRate);
  }, [conversionRate]);

  const save = async () => {
    setSaving(true);
    const success = await updateConversionRateApi(editRate);
    if (success) {
      setConversionRate(editRate);
    }
    setSaving(false);
  };

  const exampleDIN = 1500;
  const exampleKM = editRate > 0 ? (exampleDIN / editRate).toFixed(2) : "0";

  const exampleShippingKM = 15;
  const exampleShippingDIN =
    editRate > 0 ? (exampleShippingKM * editRate).toFixed(2) : "0";

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="warning">
          <IonButtons slot="start">
            <IonMenuToggle>
              <IonIcon icon={menu} style={{ fontSize: 28 }} />
            </IonMenuToggle>
          </IonButtons>
          <IonTitle>Kurs DIN / KM</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonGrid>
          <IonRow>
            <IonCol size="12" sizeMd="6" offsetMd="3">
              <IonCard>
                <IonCardContent>
                  <IonItem>
                    <IonLabel position="stacked">1 KM = koliko DIN?</IonLabel>
                    <IonInput
                      type="number"
                      value={editRate}
                      onIonChange={(e) =>
                        setEditRate(parseFloat(e.detail.value!) || 0)
                      }
                      step="0.1"
                    />
                  </IonItem>
                  <br />
                  <p style={{ padding: "0 16px" }}>
                    Primer: {exampleDIN} din = {exampleKM} KM
                  </p>
                  <p style={{ padding: "0 16px" }}>
                    Primer: {exampleShippingKM} KM = {exampleShippingDIN} din
                  </p>
                  <br />
                  <IonButton
                    onClick={save}
                    disabled={saving || editRate <= 0}
                    expand="block"
                  >
                    {saving ? "Čuvanje..." : "Sačuvaj kurs"}
                  </IonButton>
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default ConversionRate;
